import BaseSingle from "../../../engines/libs/BaseSingle";
import { ConditionKind } from "../../define/ConditionKind";
import { FileKind } from "../../define/FileKind";
import NormalGameManager from "./NormalGameManager";


export default class ConditionManage extends BaseSingle{
    static get instance() {
        return super.GetInstance<ConditionManage>();
    }

    /**
     * 解析条件
     * @param strCond 条件值
     * @returns 
     */
    parseCondition(condType: string, condValue: string, ...arg: any[]): ConditionKind.ConditionResult {
        let condRet = new ConditionKind.ConditionResult();
        
        let funName = 'parseType_'+condType;
        if (!this[funName]) {
            console.error(`没有此条件类型`);
            return null;
        }
        let condSplits = condValue.split(FileKind.ResParseType.SUB_ITEM);
        return this[funName](condRet, condSplits, ...arg);
    }

    parseType_level(condRet: ConditionKind.ConditionResult, strCond: string[], ...arg: any[]) {
        let targetValue = Number(strCond[0]);
        let gameData = NormalGameManager._instance.getGameData();
        let curValue = gameData.m_officialLv;
        condRet.cValue = curValue;
        condRet.tValue = targetValue;
        return condRet;
    }

    parseType_open_water_run(condRet: ConditionKind.ConditionResult, strCond: string[], ...arg: any[]) {
        condRet.cValue = 1;
        condRet.tValue = 1;
        return condRet;
    }
   
}
